import * as React from 'react';

const DEFAULT_LOCALE = 'en';
const DEFAULT_OPTIONS: Intl.NumberFormatOptions = { style: 'percent' };

export const Percent: React.FC<{
  locale?: string;
  value: number;
}> = ({ value, locale = DEFAULT_LOCALE }) => <>{value.toLocaleString(locale, DEFAULT_OPTIONS)}</>;
